//----- Component --------------------------------------------------------/
// Developer     : Guillermo Sedran
// Creation Date : 06/10/2025
// Version       : 1
// Description   : Activar/Anular componentes para vehiculos
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   :
// Change by     :
// Change description:
//
// Change Date   :
// Change by     :
// Change description:
//
//========================================================================/

import React, { useState } from "react";
import { UrlApi } from "../../../../services/apirest";
import {
  Box,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
  Stack,
  Snackbar,
} from "@mui/material";

//Notification
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function CambiarEstadoComponente(props) {
  const isComponenteActivo = props.componente.estado === 1;

  // Deshabilitar Botón
  const [disBtn, setDisBtn] = useState(false);

  //Notification
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");

  // ------------------------------------------------------------------

  // FUNCIONES PARA GUARDAR EL ESTADO DE LOS COMPONENTES
  const guardarActivo = async () => {
    await fetch(
      UrlApi +
        "/vehiculos_componentes/" +
        encodeURIComponent(props.componente.id),
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          estado: 1, // Activar
        }),
      }
    )
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("El componente se activó exitosamente!");
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al activar el componente");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const guardarInactivo = async () => {
    await fetch(
      UrlApi +
        "/vehiculos_componentes/" +
        encodeURIComponent(props.componente.id),
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          estado: 2, // Desactivar
        }),
      }
    )
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("El componente se desactivó exitosamente!");
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al desactivar el componente");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  // -------------------------------------

  // Manejar el guardado de estado
  const handleGuardarEstado = () => {
    if (isComponenteActivo) {
      setDisBtn(true);
      guardarInactivo(props.componente); // Si está activo, lo desactiva
    } else {
      setDisBtn(true);
      guardarActivo(props.componente); // Si está inactivo, lo activa
    }
  };

  //*************************************************************************************************************************************/

  // Snackbar Notificacion
  // Cerrar el Snackbar y realizar las acciones finales
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setDisBtn(false);
    setOpenSnack(false);

    // Acciones de cierre de diálogo y actualización después de que el Snack se cierre
    props.onComponenteGuardado(); // Función para obtener valores de nuevo en el componente padre
    props.handleCloseCambiarEstadoComponente();
  };

  return (
    <>
      <Box>
        <Box
          sx={{
            backgroundColor: "#2B76A6",
            width: "100%",
            textAlign: "center",
          }}
        >
          <DialogTitle alignSelf="center" mb={1}>
            <Typography
              sx={{
                color: "white",
                fontWeight: "bold",
              }}
            >
              {isComponenteActivo ? "ANULAR" : "ACTIVAR"} COMPONENTE
            </Typography>
          </DialogTitle>
        </Box>
      </Box>

      <DialogContent sx={{ mb: 1 }}>
        <Typography align="center">{props.componente.nombre}</Typography>
      </DialogContent>
      <Typography align="center" sx={{ fontWeight: "bold" }}>
        {isComponenteActivo
          ? "¿Desea anular este componente?"
          : "¿Desea activar este componente?"}
      </Typography>

      <DialogActions>
        <Box
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Button
            variant="contained"
            color="error"
            sx={{
              borderRadius: "12px",
              textTransform: "none",
              fontWeight: 600,
            }}
            onClick={props.handleCloseCambiarEstadoComponente}
            disabled={disBtn}
          >
            Volver
          </Button>
          <Button
            sx={{
              borderRadius: "12px",
              textTransform: "none",
              fontWeight: 600,
            }}
            onClick={handleGuardarEstado}
            variant="contained"
            disabled={disBtn}
          >
            {isComponenteActivo ? "Anular" : "Activar"}
          </Button>
        </Box>
      </DialogActions>

      {/* SNACKBAR QUE SE MOSTRARÁ AL GUARDAR LOS CAMBIOS */}
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default CambiarEstadoComponente;
